import { ClaveProductoActionTypes, ClaveProductoState, LOAD_CLAVESPRODUCTO_SUCCESS } from "../types/claveProductoActionTypes";


export default function claveProductoReducer(state = [], action: ClaveProductoActionTypes): ClaveProductoState[]{
    switch (action.type) {
        case LOAD_CLAVESPRODUCTO_SUCCESS:
            return action.clavesProducto;
        default:
            return state;
    }
}
